import React, { Component } from 'react';

import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { ModelFile } from 'hay-core-react';
import Midia                    from '../../../models/Midia';
import Routerboard               from '../../../models/Routerboard';
import Plano                     from '../../../models/Plano';
import MidiaTipoEnum             from '../../../enums/MidiaTipoEnum';
import MidiaMomentoExibicaoEnum  from '../../../enums/MidiaMomentoExibicaoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id:              { exibir: 'main.id', tipo: 'numeric', largura: '5rem', fixar: true },
    nome:            { exibir: 'main.midia.nome',            visivel: true, validacao: { obrigatorio: true } },
    ativo:           { exibir: 'main.midia.ativo',           visivel: true, tipo: 'boolean', template: 'ativo.template' },
    ordenacao:       { exibir: 'main.midia.ordenacao',       visivel: true, tipo: 'numeric' },
    tipo:            { exibir: 'main.midia.tipo',            visivel: true, tipo: 'enum', entidade: 'midia.tipo' },
    momentoexibicao: { exibir: 'main.midia.momentoexibicao', visivel: true, tipo: 'enum', entidade: 'midia.momentoexibicao' },
    redirecionar:    { exibir: 'main.midia.redirecionar' },
    routerboard: {
        exibir:       'main.midia.routerboard',
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'routerboard.entidade',
        template:     'routerboard.template',
    },
    plano: {
        exibir:       'main.midia.plano',
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'plano.entidade',
        template:     'plano.template',
    },
    imagem:    { exibir: 'main.midia.imagem' },
    video:     { exibir: 'main.midia.video' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
    ativo:                     { template: booleanTemplate('ativo') },
    'midia.tipo':              MidiaTipoEnum,
    'midia.momentoexibicao':   MidiaMomentoExibicaoEnum,
    routerboard: { entidade: Routerboard, template: (rowData) => rowData.routerboard?.descricao || '' },
    plano:       { entidade: Plano,       template: (rowData) => rowData.plano?.descricao || '' },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class MidiaFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        const tipoSelecionado = model.tipo.value?.id;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.nome} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-3 mt-3">
                    <ModelDropDown model={model.tipo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-3 mt-3">
                    <ModelBoolean model={model.ativo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.momentoexibicao} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelInputNumber model={model.ordenacao} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.redirecionar} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.routerboard} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.plano} contexto={contexto} />
                </div>
                {tipoSelecionado !== 'main.midia.tipo.video' && (
                    <div className="field col-12 md:col-6 mt-3">
                        <ModelFile model={{ ...model.imagem, accept: 'image/*' }} contexto={contexto} />
                    </div>
                )}
                {tipoSelecionado === 'main.midia.tipo.video' && (
                    <div className="field col-12 md:col-6 mt-3">
                        <ModelTextInput model={model.video} contexto={contexto} />
                    </div>
                )}
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class MidiaTemplate extends Component {
    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={Midia}
                model={model}
                identidade="main.midia"
                permissoes={this.props.permissoes}
                icone="pi-images"
                storageKey="dt-midias"
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <MidiaFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default MidiaTemplate;
